import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';

/** 推广费模块store */
@Module({
	dynamic: true,
	store,
	name: 'portal'
})
class ModuleInquery extends VuexModule {
	/** 当前场景状态  */
	public currentStatus: string = getCurrentStatus(); // 'dynamic';

	/** 用户选择的查询数据  */
	public searchQuary: any = {
		type: '',
		num: '',
		sort: ''
	};

	/** 搜索结果数据 */
	public searchResultData: any = {};

	/** 是否显示查询条件  */
	public isShowSearch: boolean = false;

	/** 是否显示查询结果  */
	public isShowResult: boolean = false;

	/** 接口查询-事件类别  */
	public eventCategory: any = '';

	/** 待办已办总数  */
	public totalNumbers: any = {
		totalTodoNum: 0,
		totalDoneNum: 0,
		smsInvitationNum: {
			todoNum: 0,
			doneNum: 0
		},
		smsEnquiryNum: {
			todoNum: 0,
			doneNum: 0
		},
		bfcOrderNum: {
			todoNum: 0,
			doneNum: 0
		},
		bfcAcceptanceNum: {
			todoNum: 0,
			doneNum: 0
		}
	};

	/** 是否管理员 */
	public isAdmin: boolean = true;

	/** 供应商信息 */
	public supplierInfo: any = {};

	/** mutation 当前场景状态  */
	@Mutation
	private SAVE_CURRENTSTATUS(payload: string): any {
		this.currentStatus = payload;
		localStorage.setItem('currentStatus', payload);
	}

	/** mutation 用户选择的数据  */
	@Mutation
	private SAVE_ORDER_NUMBER(payload: any): any {
		this.searchQuary = payload;
	}

	/** mutation 用户选择的数据  */
	@Mutation
	private SAVE_SEARCH(payload: boolean): any {
		this.isShowSearch = payload;
	}

	/** mutation 用户选择的数据  */
	@Mutation
	private SAVE_RESULT(payload: boolean): any {
		this.isShowResult = payload;
	}

	/** mutation 保存搜索结果  */
	@Mutation
	private SAVE_SEARCH_DATA(payload: any): any {
		this.searchResultData = payload;
	}

	/** mutation 用户选择的数据  */
	@Mutation
	private SAVE_EVENTCATEGORY(payload: number): any {
		const enumerate = ['todo', 'done'];
		this.eventCategory = enumerate[payload] || '';
	}

	/** mutation 待办已办总数  */
	@Mutation
	private SAVE_TOTALNUMBERS(payload: any): any {
		this.totalNumbers = payload;
	}

	/** mutation 是否管理员  */
	@Mutation
	private SAVE_ISADMIN(payload: boolean): any {
		this.isAdmin = payload;
	}

	/** mutation 保存供应商信息  */
	@Mutation
	private SAVE_SUPPLIERINFO(payload: any): any {
		this.supplierInfo = payload;
	}

	/** action 当前场景状态 */
	@Action
	public saveScurrentStatus(payload: any): any {
		this.SAVE_CURRENTSTATUS(payload);
	}

	/** action 事件类别 */
	@Action
	public saveSearchQuary(payload: any): any {
		this.SAVE_ORDER_NUMBER(payload);
	}

	/** action 保存用户选择的单据 */
	@Action
	public saveSearch(payload: boolean): any {
		this.SAVE_SEARCH(payload);
	}

	/** action 保存用户选择的单据 */
	@Action
	public saveSearchData(payload: boolean): any {
		this.SAVE_SEARCH_DATA(payload);
	}

	/** action 保存用户选择的单据 */
	@Action
	public saveResult(payload: boolean): any {
		this.SAVE_RESULT(payload);
	}

	/** action 事件类别 */
	@Action
	public saveEventCategory(payload: number): any {
		this.SAVE_EVENTCATEGORY(payload);
	}

	/** action 待办已办总数 */
	@Action
	public saveTotalNumbers(payload: number): any {
		this.SAVE_TOTALNUMBERS(payload);
	}

	/** action 是否管理员 */
	@Action
	public saveIsAdmin(payload: boolean): any {
		this.SAVE_ISADMIN(payload);
	}

	/** action 保存供应商信息 */
	@Action
	public saveSupplier(payload: any): any {
		this.SAVE_SUPPLIERINFO(payload);
	}
}

// eslint-disable-next-line require-jsdoc
export function getCurrentStatus(): string {
	const currentStatus = 'dynamic'; // localStorage.getItem('currentStatus') ?? 'dynamic';

	return currentStatus;
}

/** 推广费STORE */
export const portalModule: any = getModule(ModuleInquery);
